// -- import * as _ from "lodash-es"
import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "sPlant_Pre_Distribution"

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const descriptor = {}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)

const fields = {
  default: [
    { key: 'id', label: '编号', sortable: true, thStyle: { width: "60px" } },
    {
      key: "dataAreaId",
      label: "销售公司",
      sortable: true,
      thStyle: {
        width: "5rem"
      }
    },
    {
      key: "CompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: { width: "8rem" },
      type: "short"
    },
    {
      key: 'ItemId', label: '物料编号', sortable: true, style: "width:8rem",
      thStyle: {
        width: "8rem"
      }
    },
    {
      key: 'NameAlias', label: '物料名称', sortable: true, style: "width:10rem",
      type: "short",
      thStyle: {
        width: "10rem"
      }
    },
    { key: 'create_by_username', label: '创建人', sortable: true },
    { key: 'create_at', label: '创建时间', sortable: true, type: "datetime" },
    {
      key: "fcCheckDocumentApproved",
      label: "审批",
      sortable: true,
      type: "state",
      state_control: "fcCheckDocumentApproved",
      context: ["待审批", "已审批"],
      style: "width:4rem",
      thStyle: {
        width: "4rem"
      }
    },
    { key: "fcGetDocumentApprover", label: "审批人", sortable: true, thStyle: { width: "5rem" } },
    { key: 'fcGetDocumentApproveDatetime', label: '审批时间', sortable: true, type: "datetime" },
  ],
  detail: [
    {
      key: "AccountNum",
      label: "供应商编号",
      sortable: true,
      width: "6rem",
      thStyle: {
        width: "6rem"
      }
    },
    {
      key: "AccountName",
      label: "供应商名称",
      sortable: true,

    },
    {
      key: 'DistributionRate', label: '比例(%)', sortable: true,
      type: "number",
      width: "12rem",
      thStyle: {
        width: "12rem"
      },
      editable: true,
      required: true,
    },
    {
      key: 'Description', label: '备注', sortable: true, type: "textarea",
      editable: true,
    },
  ],
  detail_add: [
    {
      key: "dataAreaId",
      label: "销售公司",
      sortable: true,
      thStyle: {
        width: "5rem"
      }
    },

    {
      key: 'ItemId', label: '物料编号', sortable: true,
      style: "width:100%",
      thStyle: {
        width: "12rem"
      }
    },

    {
      key: "AccountNum",
      label: "供应商编号",
      sortable: true,
      width: "6rem",
      thStyle: {
        width: "6rem"
      }
    },
    {
      key: "AccountName",
      label: "供应商名称",
      sortable: true,
      thStyle: { width: "16rem" },
      width: "16rem",
      type: "short"
    },
    {
      key: 'DistributionRate', label: '比例(%)', sortable: true,
      type: "number",
      editable: true,
      required: true,
    },
    {
      key: 'Description', label: '备注', sortable: true, type: "textarea",
      editable: true
    }
  ],
  apply: [
    { key: 'id', label: '编号', sortable: true, thStyle: { width: "60px" } },
    {
      key: "dataAreaId",
      label: "销售公司",
      sortable: true,
      thStyle: {
        width: "5rem"
      }
    },
    {
      key: "CompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: { width: "12rem" },
      type: "short"
    },
    {
      key: 'ItemId', label: '物料编号', sortable: true,
    },
    {
      key: 'NameAlias', label: '物料名称', sortable: true, style: "width:12rem",
      type: "short",
      thStyle: {
        width: "12rem"
      }
    },
    { key: 'Description', label: '描述', sortable: true, width: "150px", thStyle: { width: "12rem" } },
    {
      key: 'Accessory',
      label: '附件',
      type: "button",
      button: {
        type: "text",
        icon_class: "iconfont icon-fujian",
        label: "",
        show_label: true
      },
      thStyle: { width: "80px" }
    },
    { key: 'create_by_username', label: '创建人', sortable: true },
    { key: 'create_at', label: '创建时间', sortable: true, type: "datetime" },
    {
      key: "fcCheckDocumentApproved",
      label: "审批",
      sortable: true,
      type: "state",
      state_control: "fcCheckDocumentApproved",
      context: ["待审批", "已审批"],
      style: "width:4rem",
      thStyle: {
        width: "4rem"
      }
    },
    { key: "fcGetDocumentApprover", label: "待审批人", sortable: true, thStyle: { width: "7rem" } },
  ],
}

const dataForm = {}
///前端验证
const rules = {}

const methods = {
  //获取预分配主档
  async getPreDistribution(_params) {
    let f = _.map(fields.default, "key")
    f.push("create_by")
    f.push("fcCheckDocumentApproved('SalesQuoteDistributionPre','',t.id)")
    f.push("fcGetDocumentApprover('SalesQuoteDistributionPre','',t.id)")
    f.push("fcGetDocumentApproveDatetime('SalesQuoteDistributionPre','',t.id)")
    let result = await biz_data.selectAction({ params: _params, fields: f }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  //保存预分配主档
  async savePreDistribution(params, items) {
    let detail_biz_data = new biz_data_helper.base_entity_helper("sPlant_Pre_Distribution_Detail", {}, {})
    let del_detail_biz_data = new biz_data_helper.base_entity_helper("delete_pre_distribution_detail", {}, {})
    let update_status_biz_data = new biz_data_helper.base_entity_helper("update_approve_status", {}, {})
    let qto_approve_biz_data = new biz_data_helper.base_entity_helper("sp_updateApproveStatus", {}, {})

    let f = _.map(fields.default, "key")
    let _actions = []
    for (var k in params) {
      if (k == "add" && params[k].length > 0) {
        _actions.push(
          biz_data.insertAction({
            params: params[k],
            fields: f
          }).action({ output_last_item_map: { id: "PreDistributionId" } })
        )
        if (items && items.length > 0) {
          _actions.push(
            detail_biz_data.insertAction({
              params: items,
              fields: []
            }).action({
              mixin_last_item_map: {
                PreDistributionId: "PreDistributionId"
              }
            })
          )
        }
        ///预分配审批
        _.each(params[k], (t) => {
          let sq_form = {
            itemId: "",
            documentType: "SalesQuoteDistributionPre",
            approveType: "",
            documentCreateByUsername: params.documentCreateByUsername,
            IsDefaultApproved: params.IsDefaultApproved
          }
          _actions.push(
            qto_approve_biz_data.execAction({
              params: sq_form,
              fields: ["id"]
            }).action({
              mixin_last_item_map: {
                itemId: "PreDistributionId"
              }
            })
          )
        })
      }
      else if (k == "edit" && params[k].length > 0) {
        _actions.push(
          biz_data.updateAction({
            params: params[k],
            fields: f
          }).action({})
        )
      }
      else if (k == "delete" && params[k].length > 0) {
        _actions.push(
          biz_data.removeAction({
            params: params[k],
            fields: f
          }).action({})
        )
        _actions.push(
          del_detail_biz_data.execAction({
            params: _.map(params[k], (t) => { return { PreDistributionId: t.id } }),
            fields: f
          }).action({})
        )
      }
      else if (k == "approved" && params[k] && params[k].data.length > 0) {
        ///修改审批状态
        let dt = _.map(params[k].approveStatusIdList, (t) => {
          return {
            IsApproved: t.isApproved ? 0 : 1,
            ApproveBy: params[k].local_username,
            status_id: t.id,
            ApproveRemark: "" //审批备注
          }
        })
        _actions.push(
          update_status_biz_data.execAction({
            params: dt,
            fields: ["is_update_ok", "is_all_approved"]
          }).action({})
        )
      }
    }
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let is_error = false
      _.each(result.data.BatchResult.Actions, (t) => {
        if (!t.Result.Data) {
          is_error = true
        }
      })
      if (is_error) return null
      else {
        let rt = { add: [], edit: [], delete: [] }
        _.each(result.data.BatchResult.Actions, (t) => {
          if (t.Code.indexOf("data/i/") > -1) rt.add = t.Result.Data[0]
          else if (t.Code.indexOf("data/u/") > -1) rt.edit = t.Result.Data[0]
          else if (t.Code.indexOf("data/d/") > -1) rt.delete = t.Result.Data[0]
        })
        return rt
      }
    } else {
      return null
    }
  },
  //获取预分配明细
  async getPreDistributionDetail(_params) {
    let detail_biz_data = new biz_data_helper.base_entity_helper("sPlant_Pre_Distribution_Detail", {}, {})
    let f = _.map(fields.detail, "key")
    f.push("id")
    let result = await detail_biz_data.selectAction({ params: _params, fields: f }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  //保存预分配明细
  async savePreDistributionDetail(params) {
    let f = _.map(fields.detail, "key")
    f.push("id")
    let detail_biz_data = new biz_data_helper.base_entity_helper("sPlant_Pre_Distribution_Detail", {}, {})
    let _actions = []
    for (var k in params) {
      if (k == "add" && params[k].length > 0) {
        _actions.push(
          detail_biz_data.insertAction({
            params: params[k],
            fields: f
          }).action({})
        )
      }
      else if (k == "edit" && params[k].length > 0) {
        _actions.push(
          detail_biz_data.updateAction({
            params: params[k],
            fields: f
          }).action({})
        )
      }
      else if (k == "delete" && params[k].length > 0) {
        _actions.push(
          detail_biz_data.removeAction({
            params: params[k],
            fields: f
          }).action({})
        )
      }
    }
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let is_error = false
      _.each(result.data.BatchResult.Actions, (t) => {
        if (!t.Result.Data) {
          is_error = true
        }
      })
      if (is_error) return null
      else {
        let rt = { add: [], edit: [], delete: [] }
        _.each(result.data.BatchResult.Actions, (t) => {
          if (t.Code.indexOf("data/i/") > -1) rt.add = t.Result.Data[0]
          else if (t.Code.indexOf("data/u/") > -1) rt.edit = t.Result.Data[0]
          else if (t.Code.indexOf("data/d/") > -1) rt.delete = t.Result.Data[0]
        })
        return rt
      }
    } else {
      return null
    }
  },
  //获取预分配变更申请
  async getPreDistributionApply(_params) {
    let apply_biz_data = new biz_data_helper.base_entity_helper("sPlant_Pre_Distribution_Apply", {}, {})
    let f = _.map(fields.apply, "key")
    f.push("approved_by")
    f.push("create_by")
    f.push("DistributionJson")
    f.push("fcCheckInventPreDistributionExists(t.ItemId,t.dataAreaId)")
    f.push("fcCheckDocumentApproved('SalesQuoteDistributionPreApply','',t.id)")
    f.push("fcGetDocumentApprover('SalesQuoteDistributionPreApply','',t.id)")

    let result = await apply_biz_data.selectAction({ params: _params, fields: f }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  //保存预分配变更申请
  async savePreDistributionApply(params, items) {
    let apply_biz_data = new biz_data_helper.base_entity_helper("sPlant_Pre_Distribution_Apply", {}, {})
    let renew_biz_data = new biz_data_helper.base_entity_helper("renew_pre_distribution_from_apply", {}, {})
    let qto_approve_biz_data = new biz_data_helper.base_entity_helper("sp_updateApproveStatus", {}, {})
    let update_status_biz_data = new biz_data_helper.base_entity_helper("update_approve_status", {}, {})

    let f = _.map(fields.default, "key")
    let _actions = []
    for (var k in params) {
      if (k == "add" && params[k].length > 0) {
        _actions.push(
          apply_biz_data.insertAction({
            params: params[k],
            fields: f
          }).action({ output_last_item_map: { id: "PreDistributionApplyId" } })
        )
        ///预分配申请审批
        _.each(params[k], (t) => {
          let sq_form = {
            itemId: "",
            documentType: "SalesQuoteDistributionPreApply",
            approveType: "",
            documentCreateByUsername: params.documentCreateByUsername
          }
          _actions.push(
            qto_approve_biz_data.execAction({
              params: sq_form,
              fields: ["id"]
            }).action({
              mixin_last_item_map: {
                itemId: "PreDistributionApplyId"
              }
            })
          )
        })
      }
      else if (k == "edit" && params[k].length > 0) {
        _actions.push(
          apply_biz_data.updateAction({
            params: params[k],
            fields: f
          }).action({})
        )
        ///预分配申请审批
        _.each(params[k], (t) => {
          let sq_form = {
            itemId: t.id,
            documentType: "SalesQuoteDistributionPreApply",
            approveType: "",
            documentCreateByUsername: params.documentCreateByUsername
          }
          _actions.push(
            qto_approve_biz_data.execAction({
              params: sq_form,
              fields: ["id"]
            }).action({})
          )
        })
      }
      else if (k == "delete" && params[k].length > 0) {
        _actions.push(
          apply_biz_data.removeAction({
            params: params[k],
            fields: f
          }).action({})
        )
      }
      else if (k == "approved" && params[k] && params[k].data && params[k].data.length > 0) {
        ///修改审批状态
        let dt = _.map(params[k].approveStatusIdList, (t) => {
          return {
            IsApproved: t.isApproved ? 0 : 1,
            ApproveBy: params[k].local_username,
            status_id: t.id,
            ApproveRemark: "" //审批备注
          }
        })
        _actions.push(
          update_status_biz_data.execAction({
            params: dt,
            fields: ["is_update_ok", "is_all_approved"]
          }).action({})
        )
        ///更新到预分配
        if (items && items.length > 0) {
          _actions.push(
            renew_biz_data.execAction({
              params: items,
              fields: f
            }).action({})
          )
        }
      }
      else if (k == "renew_pre_distribution") {
        ///更新到预分配
        if (items && items.length > 0) {
          _actions.push(
            renew_biz_data.execAction({
              params: items,
              fields: f
            }).action({})
          )
        }
      }
    }
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let is_error = false
      _.each(result.data.BatchResult.Actions, (t) => {
        if (!t.Result.Data) {
          is_error = true
        }
      })
      if (is_error) return null
      else {
        let rt = { add: [], edit: [], delete: [] }
        _.each(result.data.BatchResult.Actions, (t) => {
          if (t.Code.indexOf("data/i/") > -1) rt.add = t.Result.Data[0]
          else if (t.Code.indexOf("data/u/") > -1) rt.edit = t.Result.Data[0]
          else if (t.Code.indexOf("data/d/") > -1) rt.delete = t.Result.Data[0]
        })
        return rt
      }
    } else {
      return null
    }
  },
}
export { biz_data, dataForm, fields, methods, rules };

